module.exports = __webpack_public_path__ + "img/204.4c1d7f71.jpg";